import PageForm from './PageForm/index.js'

export default PageForm
